import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalytics } from '../hooks/useAnalytics';

interface AnalyticsTrackerProps {
  children?: React.ReactNode;
}

export const AnalyticsTracker: React.FC<AnalyticsTrackerProps> = ({ children }) => {
  const location = useLocation();
  const { trackCurrentPage } = useAnalytics();

  useEffect(() => {
    // Track page view when location changes
    trackCurrentPage();
  }, [location, trackCurrentPage]);

  // This component doesn't render anything, it just tracks analytics
  return <>{children}</>;
};

export default AnalyticsTracker;
